import { Tooltip } from '../../../../components/UI/MDC/Tooltip/Tooltip';
import { CONTENT_ALIGNMENT } from '../../../../components/UI/MDC/Tooltip/_types';
import styles from './ApplicationForm.module.scss';

/**
 * Reusable 'required' indicator
 * @returns Indicator for when a field is required
 */
const RequiredIndicator = () => {
	return (
		<Tooltip content='Required' align={CONTENT_ALIGNMENT.RIGHT}>
			<span className={styles['required']}>* </span>
		</Tooltip>
	);
};

export default RequiredIndicator;
